<div style="max-height: 20vh;">
  <br>
  <div>
    <span class="fw-extrabold fs-4">Productos disponibles</span>
  </div>
  <div class="my-3">
    <span class="fs-6 fw-regular">Elige el producto que deseas asignar a este cliente.</span>
  </div>
  <div class="row mx-0">
    <div class="col-md-4 mb-3" *ngFor="let p of productsList">
      <div class="pointer d-flex flex-column" (click)="changeStateProduct(p)" [ngClass]="p.selected ? 'content-product-selected':'content-product'">
        <div class="product-top p-3" [ngClass]="p.selected ? 'bg-blue-2':''">
          <div>
            <img [src]="p.selected ? 'assets/svg/Icon_product_card_selected.svg':'assets/svg/Icon_product_card.svg'" width="20" alt="">
          </div>
          <div>
            <span class="fs-7 fw-semibold" [ngClass]="p.selected ? 'text-white':''">{{p?.titulo}}</span>
          </div>
        </div>
        <div class="product-bottom p-3 d-flex flex-column h-100 sp-end">
          <div>
            <!-- <span class="fw-semibold fs-7 text-blue">{{p.tituloSecond}}</span> -->
            <span class="fw-semibold fs-7 text-blue">Lorem ipsum</span>
          </div>
          <div>
            <span class="fw-semibold fs-7" [ngClass]="p.selected ? 'text-blue-2':'text-gray'">{{p?.descripcion}}</span>
          </div>
          <br>
          <div class="d-flex al-center gap">
            <img [src]="p.selected ? 'assets/svg/Icon_money_selected.svg':'assets/svg/Icon_money.svg'" alt="" width="20">
            <img [src]="p.selected ? 'assets/svg/Icon_stats_selected.svg':'assets/svg/Icon_stats.svg'" alt="" width="20">
            <img [src]="p.selected ? 'assets/svg/Icon_part_selected.svg':'assets/svg/Icon_part.svg'" alt="" width="20">
            <img [src]="p.selected ? 'assets/svg/Icon_up_selected.svg':'assets/svg/Icon_up.svg'" alt="" width="20">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>